import React, { Fragment, useEffect, useState, useMemo, useCallback } from "react";
import {
  Table,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  CardHeader,
  Nav,
  NavItem,
  NavLink,
  Row,
  Modal,
  ModalHeader,
  Form,
  ModalBody,
  Label,
  Input,
  FormFeedback,
  Spinner,
} from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import { isEmpty } from "lodash";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

import {
  EditorState,
  convertToRaw,
  convertFromHTML,
  ContentState,
} from "draft-js";
import htmlToDRAFT from "html-to-draftjs";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import "../../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import {
  useTable,
  useGlobalFilter,
  useAsyncDebounce,
  useSortBy,
  useFilters,
  useExpanded,
  usePagination,
  useRowSelect,
} from "react-table";

import Flatpickr from "react-flatpickr";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import {
  getPrintTemplate as onGetPrintTemplates,
  addNewPrintTemplate as onAddNewPrintTemplate,
  updatePrintTemplate as onUpdatePrintTemplate,
  deletePrintTemplate as onDeletePrintTemplate,
  getPrintTemplateLoading,
} from "../../../store/printTemplate/action";
import { getClient, resetClientState } from "../../../store/client/action";
import { resetCompanyState, getCompany } from "../../../store/company/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import defaultImg from "../../../assets/images/upload.png";

import PropTypes from "prop-types";
import withRouter from "../../../Components/Common/withRouter";
import { withTranslation } from "react-i18next";

const PrintTemplate = (props) => {
  const [editorContent, setEditorContent] = React.useState(
    EditorState.createEmpty()
  );
  const { t } = props;
  const [modal, setModal] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [logo, setLogo] = useState(defaultImg);
  const dispatch = useDispatch();
  const [quillValue, setQuillValue] = useState();

  const {
    printTemplates,
    isPrintTemplateCreated,
    isPrintTemplateSuccess,
    loading,
    error,
    isMediaDeleted,
    media,
    mediaLoading,
    clients,
    clientLoading,
    companies,
    companyLoading,
  } = useSelector((state) => ({
    printTemplates: state.PrintTemplate.printTemplates,
    isPrintTemplateCreated: state.PrintTemplate.isPrintTemplateCreated,
    isPrintTemplateSuccess: state.PrintTemplate.isPrintTemplateSuccess,
    loading: state.PrintTemplate.loading,
    error: state.PrintTemplate.error,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
  }));

  const [printTemplateList, setPrintTemplateList] = useState([]);
  const [printTemplate, setPrintTemplate] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const statusActiveData = [
    {
      options: [
        { label: "Active", value: "1" },
        { label: "Inactive", value: "2" },
      ],
    }];

  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [userRole, setRoles] = useState(null);
  const [userType, setUserType] = useState("user");
  const [userData, setUserData] = useState(null);
  const [isDisabledUserType, setIsDisabledUserType] = useState(false);
  const [clientList, setClientList] = useState([]);
  const [companyList, setCompanyList] = useState([]);

  const onClickDelete = (printTemplate) => {
    setPrintTemplate(printTemplate);
    setDeleteModal(true);
  };

  const handleDeletePrintTemplate = () => {
    if (printTemplate) {
      dispatch(onDeletePrintTemplate(printTemplate));
      setDeleteModal(false);
    }
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  // useEffect(() => {
  //   dispatch(resetClientState());
  //   dispatch(getClient({ status: 1 }));
  // }, [dispatch]);

  // useEffect(() => {
  //   if (!isEmpty(clients)) {
  //     var data = [];
  //     var opt = [];
  //     clients.forEach((item, key) => {
  //       const name = item.name;
  //       const id = item.id;
  //       var obj = { label: name, value: id };
  //       opt.push(obj);
  //     });
  //     var option = { options: opt };
  //     data.push(option);
  //     setClientList(data);
  //   }
  // }, [clients]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (companies || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (companies.length > 0) {
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    setPrintTemplateList(printTemplates);
  }, [printTemplates]);

  useEffect(() => {
    if (!isEmpty(printTemplates)) setPrintTemplateList(printTemplates);
  }, [printTemplates]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      let filteredPrintTemplates = printTemplates;
      if (type !== "all") {
        filteredPrintTemplates = printTemplates.filter(
          (printTemplate) => printTemplate.bast_template_status.name === type
        );
      }
      setPrintTemplateList(filteredPrintTemplates);
    }
  };

  useEffect(() => {
    if (!isSearch) {
      dispatch(onGetPrintTemplates());
    }
    setIsSearch(true);
    const obj = JSON.parse(localStorage.getItem("authUser"));
    // if (
    //   obj.data &&
    //   obj?.data?.user?.user_position &&
    //   obj?.data?.user?.user_position?.position_role
    // )
    //   setRoles(obj?.data?.user?.user_position?.position_role.method);
    // else setRoles(null);

    if (obj?.data) {
      setUserData(obj.data);
      // setCompanyName({
      //   label: obj?.data?.user.user_company.name,
      //   value: obj?.data?.user.user_company.id,
      // });
      if (
        obj?.data?.user?.user_position &&
        obj?.data?.user?.user_position?.position_role.method
      ) {
        setRoles(obj?.data?.user?.user_position?.position_role.method);
      }
    } else setRoles(null);

    if (obj.data && obj?.data?.userType) setUserType(obj?.data?.userType);
  }, [dispatch, printTemplates, isSearch]);

  useEffect(() => {
    setPrintTemplate(printTemplates);
  }, [printTemplates]);

  useEffect(() => {
    if (!isEmpty(printTemplates)) {
      setPrintTemplate(printTemplates);
      setIsEdit(false);
    }
  }, [printTemplates]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setPrintTemplate(null);
      setLogo(defaultImg);
      setClientList([]);
      setCompanyList([]);
      dispatch(resetCompanyState());
      dispatch(resetClientState());
      validation.resetForm();
      validation.setErrors({});
      setIsDisabledUserType(false);
      setEditorContent(EditorState.createEmpty());
    } else {
      setModal(true);
      dispatch(getClient());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modal]);

  const handlePrintTemplateClick = useCallback((arg) => {
    const printTemplate = arg;

    // task_print_template_client
    setEditorContent(
      EditorState.createWithContent(
        ContentState.createFromBlockArray(
          htmlToDRAFT(printTemplate.description)
        )
      )
    );
    setPrintTemplate({
      id: printTemplate.id,
      name: printTemplate.name,
      description: printTemplate.description,
      client:
        printTemplate.task_print_template_client && {
          label: printTemplate.task_print_template_client
            ? printTemplate.task_print_template_client.name
            : "",
          value: printTemplate.task_print_template_client
            ? printTemplate.task_print_template_client.id
            : "",
        },
      company:
        printTemplate.task_print_template_company && {
          label: printTemplate.task_print_template_company
            ? printTemplate.task_print_template_company.name
            : "",
          value: printTemplate.task_print_template_company
            ? printTemplate.task_print_template_company.id
            : "",
        },
      status: printTemplate.printTemplate_status
        ? {
          label: printTemplate.printTemplate_status.name,
          value: printTemplate.printTemplate_status.id,
        }
        : printTemplate.statusId
          ? {
            label: printTemplate.statusId === 1 ? "Active" : "Inactive",
            value: printTemplate.statusId,
          }
          : "",
    });

    switch (userType) {
      case "admin":
        setIsDisabledUserType(false);
        break;

      default:
        setIsDisabledUserType(true);
        break;
    }

    setIsEdit(true);
    toggle();
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [toggle, userType]);

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      name: (printTemplate && printTemplate.name) ?? "",
      description: (printTemplate && printTemplate.description) ?? "",
      status: (printTemplate && printTemplate.status) ?? "",
      client: (printTemplate && printTemplate.client) ?? "",
      company: (printTemplate && printTemplate.company) ?? "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Isi Nama"),
    }),
    onSubmit: (values) => {
      // dispatch(getPrintTemplateLoading());
      if (isEdit) {
        const editPrintTemplate = {
          id: printTemplate ? printTemplate.id : 0,
          name: values.name,
          description: draftToHtml(
            convertToRaw(editorContent.getCurrentContent())
          ),
          statusId: values.status.value,
          clientId: values.client.value,
          companyId: values.company.value,
        };
        dispatch(onUpdatePrintTemplate(editPrintTemplate));
        validation.resetForm();
      } else {
        const newPrintTemplate = {
          name: values.name,
          description: draftToHtml(
            convertToRaw(editorContent.getCurrentContent())
          ),
          statusId: values.status.value,
          clientId: values.client.value,
          companyId: values.company.value,
        };
        dispatch(onAddNewPrintTemplate(newPrintTemplate));
        validation.resetForm();
      }
      toggle();
    },
  });

  const checkedAll = () => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".dataCheckbox");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  };

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeletePrintTemplate(element.value));
    });
    checkall.checked = false;
  };

  // able Column
  const columns = useMemo(
    () => [
      {
        Header: (
          <input
            type='checkbox'
            id='checkBoxAll'
            className='form-check-input'
            onClick={() => checkedAll()} />
        ),
        Cell: (cellProps) => {
          return (
            <input
              type='checkbox'
              className='dataCheckbox form-check-input'
              value={cellProps.row.original.id}
            />
          );
        },
        id: "#",
      },
      {
        Header: " ",
        filterable: false,
        Cell: (cellProps) => {
          return (
            <div className='hstack gap-2 mt-4 mt-sm-0'>
              <Link
                to='#'
                className={`btn-icon btn btn-sm btn-light edit-item-btn`}
                onClick={() => {
                  const printTemplateData = cellProps.row.original;
                  handlePrintTemplateClick(printTemplateData);
                }}>
                <i className='ri-edit-2-line fs-15'></i>
              </Link>
              <Link
                to='#'
                className={`btn-icon btn btn-sm btn-soft-danger remove-item-btn`}
                onClick={() => {
                  const printTemplateData = cellProps.row.original;
                  onClickDelete(printTemplateData);
                }}>
                <i className='ri-delete-bin-line fs-15 text-danger'></i>
              </Link>
            </div>
          );
        },
      },
      {
        Header: "Nama",
        accessor: "name",
        filterable: true,
        Cell: (printTemplate) => (
          <>
            <div className='d-flex align-items-center'>
              <div className='flex-shrink-0'>
                <div className='flex-shrink-0 avatar-xs me-2'>
                  <div className='avatar-title bg-soft-success text-success rounded-circle fs-13'>
                    {printTemplate.row.original.name.charAt(0).toUpperCase()}
                  </div>
                </div>
              </div>
              <div className='flex-grow-1 ms-2 name'>
                {printTemplate.row.original.name}
              </div>
            </div>
          </>
        ),
      },
      {
        Header: "Grup Usaha",
        accessor: "bast_template_client.name",
        filterable: true,
      },
      {
        Header: "Keterangan",
        accessor: "description",
        filterable: true,
      },
      {
        Header: "Status",
        accessor: "bast_template_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.value) {
            case "Active":
              return (
                <span className='badge text-uppercase badge-soft-info'>
                  {cell.value}
                </span>
              );
            case "Inactive":
              return (
                <span className='badge text-uppercase badge-soft-danger'>
                  {cell.value}
                </span>
              );
            default:
              return (
                <span className='badge text-uppercase badge-soft-warning'>
                  {cell.value}
                </span>
              );
          }
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [handlePrintTemplateClick, userType, userRole]);

  const defaultdate = () => {
    return moment().format("YYYY/MM/DD HH:mm:ss").toString();
  };

  const [filterDate, setFilterDate] = useState(null);

  const handleSubscribedAt = (date) => {
    validation.setFieldValue("subscribedat", date);
  };

  const handleExpirededAt = (date) => {
    validation.setFieldValue("expiredat", date);
  };

  const handleValidDate = (date) => {
    return moment(new Date(date), "YYYY/MM/DD")

      .format("MMM D, YYYY");
  };

  const handleValidTime = (time) => {
    return moment(new Date(time), "YYYY/MM/DD")

      .format("HH:mm");
  };

  //TABLE
  const {
    getTableProps, rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: printTemplateList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 10,
        selectedRowIds: 0,

      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable
      ? column.isSorted
        ? column.isSortedDesc
          ? " sorting_desc"
          : " sorting_asc"
        : " sort"
      : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };
  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);
  const onChange = useAsyncDebounce((value) => { setGlobalFilter(value || undefined); }, 600);

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
    };
    dispatch(onGetPrintTemplates(param));
  }

  function handleLogoChange(event) {
    if (event.target.files && event.target.files[0]) {
      setLogo(URL.createObjectURL(event.target.files[0]));
      validation.setFieldValue("img", event.target.files[0]);
    }
  }

  const handleGetCompany = (id) => {
    dispatch(resetCompanyState());
    dispatch(getCompany({ clientId: id }));
  };

  const setInputType = (type) => {
    if (userData) {
      switch (type) {
        case "user":
          setPrintTemplate({
            client:
              userData.clientId === null
                ? ""
                : {
                  label: userData.client_name ? userData.client_name : "",
                  value: userData.clientId ? userData.clientId : "",
                },
            company:
              userData.companyId === null
                ? ""
                : {
                  label: userData.company_name ? userData.company_name : "",
                  value: userData.companyId ? userData.companyId : "",
                },
          });
          setIsDisabledUserType(true);
          break;
        case "client":
          setPrintTemplate({
            client:
              userData.clientId === null
                ? ""
                : {
                  label: userData.client_name ? userData.client_name : "",
                  value: userData.clientId ? userData.clientId : "",
                },
          });
          handleGetCompany(userData.clientId);
          setIsDisabledUserType(true);
          break;
        case "company":
          setPrintTemplate({
            client:
              userData.clientId === null
                ? ""
                : {
                  label: userData.client_name ? userData.client_name : "",
                  value: userData.clientId ? userData.clientId : "",
                },
            company:
              userData.companyId === null
                ? ""
                : {
                  label: userData.company_name ? userData.company_name : "",
                  value: userData.companyId ? userData.companyId : "",
                },
          });
          setIsDisabledUserType(true);
          break;

        default:
          setPrintTemplate("");
          setIsDisabledUserType(false);
          break;
      }
    }
  };

  // useEffect(() => {
  //   if (quill && validation.values.description) {
  //     quill.clipboard.dangerouslyPasteHTML(validation.values.description);
  //   }
  // }, [quill, validation]);

  // useEffect(() => {
  //   if (quill) {
  //     let datas;
  //     quill.on("text-change", (delta, oldDelta, source) => {
  //       if (quillRef.current && quillRef.current.firstChild) {
  //         datas = quillRef.current.firstChild.innerHTML;
  //       }
  //     });
  //     setQuillValue(datas);
  //   }
  // }, [quill, quillRef, validation]);

  // useEffect(() => {
  //   if (quillValue) {
  //     validation.setFieldValue("description", quillValue);
  //   }
  // }, [quillValue, validation]);

  document.title = "BAST Template | Enterprise Resources Planning";
  return (
    <div className='page-content'>
      <ExportCSVModal
        show={isExportCSV}
        onCloseClick={() => setIsExportCSV(false)}
        data={printTemplateList} />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeletePrintTemplate}
        onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)} />
      <Container fluid>
        <BreadCrumb title='BAST Template' pageTitle='Penugasan  ' />
        <Row>
          <Col lg={12}>
            <Card id='printTemplateList'>
              <CardHeader className='card-header border-0'>
                <div className='d-flex align-items-center'>
                  <h5 className='card-title mb-0 flex-grow-1'>
                    BAST Template &nbsp;
                    {isLoading ? (
                      <>
                        <Spinner color='primary' type='grow' size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                        <Spinner color='success' type='grow' size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                      </>
                    ) : (
                      ""
                    )}
                  </h5>
                  <div className='flex-shrink-0'>
                    <button
                      type='button'
                      className={`btn btn-primary add-btn me-2`}
                      id='create-btn'
                      onClick={() => {
                        setInputType(userType);
                        setIsEdit(false);
                        toggle();
                      }}>
                      <i className='ri-building-line me-1 align-bottom fs-14'></i>Tambah
                    </button>
                    <button
                      type='button'
                      className='btn btn-success'
                      onClick={() => setIsExportCSV(true)}>
                      <i className='ri-file-download-line me-1 align-bottom fs-14'></i>Export
                    </button>
                    <button
                      className={
                        userType === "internal"
                          ? "btn btn-soft-danger"
                          : userRole &&
                            userRole.split(",").indexOf("deletePrintTemplate") !==
                            -1
                            ? "btn btn-soft-danger"
                            : "btn btn-soft-danger d-none"
                      }
                      onClick={() => setDeleteModalMulti(true)}>
                      <i className='ri-delete-bin-5-line me-1 align-bottom fs-15'></i>Hapus
                    </button>
                  </div>
                </div>
              </CardHeader>
              <CardBody className='pt-0'>
                <div>
                  <Nav
                    className='nav-tabs nav-tabs-custom nav-success'
                    role='tablist'>
                    <NavItem>
                      <NavLink
                        className={classnames(
                          { active: activeTab === "1" },
                          "fw-semibold"
                        )} onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href='#'>
                        <i className='ri-building-line me-1 align-bottom fs-14'></i>All BAST Templates
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames(
                          { active: activeTab === "3" },
                          "fw-semibold"
                        )} onClick={() => {
                          toggleTab("3", "Active");
                        }}
                        href='#'>
                        <i className='ri-checkbox-circle-line me-1 align-bottom fs-14'></i>Active</NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames(
                          { active: activeTab === "4" },
                          "fw-semibold"
                        )} onClick={() => {
                          toggleTab("4", "Inactive");
                        }}
                        href='#'>
                        <i className='ri-indeterminate-circle-line me-1 align-bottom fs-14'></i>Inactive
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className='mb-3'>
                    <CardBody className='border border-top-0 border-end-0 border-start-0'>
                      <form>
                        <Row>
                          <Col sm={1} className='col-xxl-1'>
                            <div className='me-2 mb-2 col-12'>
                              <select
                                className='form-select'
                                value={pageSize}
                                onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={4}>
                            <div className='search-box me-2 mb-2 d-inline-block col-12'>
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id='search-bar-0'
                                type='text'
                                className='form-control search'
                                placeholder={`${count} Search...`}
                                value={searchValue ?? ""} /><i className='bx bx-search-alt search-icon'></i>
                            </div>
                          </Col>
                          <Col sm={6} className='col-xxl-3'>
                            <div className='search-box mb-2'>
                              <Flatpickr
                                className='form-control'
                                id='datepicker-publish-input'
                                placeholder='Select created date'
                                options={{
                                  mode: "range",
                                  dateFormat: "Y/m/d",
                                }}
                                onChange={(obj, str) => {
                                  setFilterDate(str);
                                }} /><i className='bx bx-calendar-alt search-icon'></i>
                            </div>
                          </Col>
                          <Col sm={4} className='col-xxl-2'>
                            <div className='me-2 mb-2 col-12'>
                              <Select
                                value={statusActive}
                                placeholder='Select Status'
                                onChange={(e) => {
                                  setStatusActive(e);
                                }}
                                options={statusActiveData}
                                name='choices-single-default'
                                id='idStatus'></Select>
                            </div>
                          </Col>
                          <Col className='col-xxl-2'>
                            <div>
                              <button
                                type='button'
                                className='btn btn-light w-100'
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleFilter();
                                }}>
                                <i className='ri-search-line me-1 align-bottom fs-14'></i>        Search
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className='table-responsive table-card mb-1'>
                    <Table
                      hover
                      {...getTableProps()}
                      className='align-middle table-nowrap'>
                      <thead className='table-light'>
                        {headerGroups.map((headerGroup, index) => (
                          <tr
                            {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th
                                {...column.getSortByToggleProps()} className={"" + generateFilterable(column)} key={index}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className='justify-content-md-end justify-content-center align-items-center p-2'>
                    <Col className='col-md-auto'>
                      <div className='d-flex gap-1'>
                        <Button
                          color='light'
                          onClick={previousPage}
                          disabled={!canPreviousPage}>{"<"}</Button>
                      </div>
                    </Col>
                    <Col className='col-md-auto d-none d-md-block'>
                      Page{pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className='col-md-auto'>
                      <Input
                        type='number'
                        min={1}
                        style={{ width: 70 }}
                        max={pageOptions.length}
                        defaultValue={pageIndex + 1}
                        onChange={onChangeInInput}
                      />
                    </Col>

                    <Col className='col-md-auto'>
                      <div className='d-flex gap-1'>
                        <Button
                          className='btn btn-light'
                          onClick={nextPage}
                          disabled={!canNextPage}>{">"}</Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal
                  id='showModal'
                  isOpen={modal}
                  centered
                  fullscreen={false}
                  size='lg'>
                  <ModalHeader className='bg-light p-3' toggle={toggle}>
                    {!!isEdit ? "Edit PrintTemplate" : "Tambah BAST Template"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}>
                    <ModalBody>
                      <Row>
                        <Col lg={12}>
                          <div className='mb-3'>
                            <Label
                              htmlFor='client-field'
                              className='form-label'>
                              Grup Usaha&nbsp;
                              {clientLoading ? (
                                <Spinner color='primary' size='sm'>
                                  Loading...
                                </Spinner>
                              ) : (
                                ""
                              )}
                            </Label>
                            <Select
                              name='client'
                              value={validation.values.client}
                              isDisabled={isDisabledUserType}
                              placeholder='Pilih Grup Usaha'
                              onChange={(e) => {
                                setCompanyList([]);
                                validation.setFieldValue("company", "");
                                validation.setFieldValue("client", e);
                                handleGetCompany(e.value);
                              }}
                              options={clientList}></Select>
                            {validation.touched.client &&
                              validation.errors.client ? (
                              <small className='text-danger' type='invalid'>
                                {validation.errors.client}
                              </small>
                            ) : null}
                          </div>

                          <div className='mb-3'>
                            <Label
                              htmlFor='company-field'
                              className='form-label'>
                              Perusahaan&nbsp;
                              {companyLoading ? (
                                <Spinner color='primary' size='sm'>
                                  Loading...
                                </Spinner>
                              ) : (
                                ""
                              )}
                            </Label>
                            <Select
                              name='company'
                              value={validation.values.company}
                              placeholder='Select Company'
                              isDisabled={companyList.length > 0 ? false : true}
                              onChange={(e) => {
                                validation.setFieldValue("company", e);
                              }}
                              options={companyList}></Select>
                            {validation.touched.company &&
                              validation.errors.company ? (
                              <small className='text-danger' type='invalid'>
                                {validation.errors.company}
                              </small>
                            ) : null}
                          </div>
                          <div className='mb-3'>
                            <Label htmlFor='name-field' className='form-label'>
                              Name    </Label>
                            <Input
                              name='name'
                              id='name-field'
                              className='form-control'
                              placeholder='Isi Nama'
                              type='text'
                              validate={{ required: { value: true } }}
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.name ?? ""}
                              invalid={
                                validation.touched.name &&
                                  validation.errors.name
                                  ? true
                                  : false
                              } />
                            {validation.touched.name &&
                              validation.errors.name ? (
                              <FormFeedback type='invalid'>
                                {validation.errors.name}
                              </FormFeedback>
                            ) : null}
                          </div>
                          <div className='mb-3'>
                            <Label
                              htmlFor='active-status'
                              className='form-label'>
                              Status
                            </Label>
                            <Select
                              name='status'
                              value={validation.values.status}
                              validate={{ required: { value: true } }}
                              placeholder='Select Status'
                              onChange={(e) => {
                                validation.setFieldValue("status", e);
                              }}
                              onInputChange={(e) => {
                                // handleUnit(e);
                              }}
                              options={statusActiveData}
                              invalid={
                                validation.touched.status &&
                                  validation.errors.status
                                  ? true
                                  : false
                              }></Select>
                            {validation.touched.status &&
                              validation.errors.status ? (
                              <p className='text-danger' type='invalid'>
                                {validation.errors.status}
                              </p>
                            ) : null}
                          </div>
                          <div className='mb-3'>
                            <Label htmlFor='des-field' className='form-label'>
                              {t("Keterangan")}
                            </Label>
                            {/* <Input
                            name="description"
                            id="clientname-field"
                            className="form-control"
                            placeholder="Enter Keterangan"
                            type="textarea"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.description ?? ""}/> */}
                            {/* <CKEditor
                              editor={ClassicEditor}
                              config={{
                                toolbar: {
                                  items: [
                                    'heading',
                                    '|',
                                    'bold',
                                    'italic',
                                    'link',
                                    'bulletedList',
                                    'numberedList',
                                    'alignment',
                                    'imageUpload',
                                    'blockQuote',
                                    'undo',
                                    'redo'
                                  ]
                                },
                                alignment: {
                                  options: ['left', 'right', 'center', 'justify']
                                },
                                removePlugins: ["EasyImage", "ImageUpload", "MediaEmbed"],
                              }}
                              data={validation.values.description}
                              onReady={(editor) => {
                                editor.editing.view.change((writer) => {
                                  writer.setStyle("height", "150px", editor.editing.view.document.getRoot());
                                });
                              }}
                              onChange={(event, editor) => {
                                const data = editor.getData();
                                validation.setFieldValue("description", data);
                              }} /> */}
                            <div>
                              <Editor
                                editorState={editorContent}
                                wrapperClassName='demo-wrapper'
                                editorClassName='demo-editor'
                                onEditorStateChange={(e) => {
                                  setEditorContent(e);
                                }} />
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </ModalBody>
                    <div className='modal-footer mb3'>
                      <div className='hstack gap-2 justify-content-end'>
                        <button
                          type='button'
                          className='btn btn-light'
                          onClick={() => {
                            setModal(false);
                            validation.resetForm();
                          }}>
                          Cancel</button>
                        <button type='submit' className='btn btn-success'>
                          <span className='d-flex align-items-center'>
                            <span className='flex-grow-1 me-2'>
                              {!!isEdit ? "Update" : "Tambah BAST Template"}
                            </span>
                            {loading ? (
                              <Spinner
                                size='sm'
                                className='flex-shrink-0'
                                role='status'>
                                Loading...
                              </Spinner>
                            ) : (
                              ""
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>

              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

PrintTemplate.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(PrintTemplate));
